const GEOAPIFY_ENDPOINT = 'https://api.geoapify.com/v1/geocode/search';
const ACCEPT_CONFIDENCE = 0.75;
const NZ_POSTCODE_PATTERN = /^\d{4}$/;

function getCountryFilters() {
  const filters = window.theme?.settings?.storeLocator?.countryFilters ?? 'nz';

  return filters
    .split(',')
    .map((code) => code.trim().toLowerCase())
    .filter(Boolean)
    .join(',');
}

function getGeoapifyApiKey() {
  return window.theme?.settings?.storeLocator?.geoapifyApiKey?.trim() ?? '';
}

function buildGeocodeUrl(query) {
  const countryFilters = getCountryFilters();
  const params = new URLSearchParams({
    text: query,
    format: 'json',
    limit: '5',
    apiKey: getGeoapifyApiKey(),
  });

  if (countryFilters) {
    params.set('filter', `countrycode:${countryFilters}`);
  }

  if (NZ_POSTCODE_PATTERN.test(query)) {
    params.set('type', 'postcode');
  }

  return `${GEOAPIFY_ENDPOINT}?${params.toString()}`;
}

function normalizeResult(result, query) {
  return {
    latitude: result.lat,
    longitude: result.lon,
    formatted: result.formatted,
    postcode: result.postcode ?? null,
    query,
  };
}

function pickBestResult(results) {
  const topResult = results?.[0];

  if (!topResult) {
    return null;
  }

  const confidence = topResult.rank?.confidence ?? 0;

  if (confidence < ACCEPT_CONFIDENCE) {
    return null;
  }

  return topResult;
}

async function fetchGeoapify(query) {
  const response = await fetch(buildGeocodeUrl(query));

  if (!response.ok) {
    throw new Error(`Geoapify request failed (${response.status})`);
  }

  const payload = await response.json();
  const bestResult = pickBestResult(payload.results);

  if (!bestResult) {
    return null;
  }

  return normalizeResult(bestResult, query);
}

/**
 * Forward-geocode a postcode or suburb via Geoapify.
 * Returns null when the query cannot be resolved with sufficient confidence.
 */
export async function geocodeSearch(query) {
  const trimmedQuery = query?.trim();

  if (!trimmedQuery) {
    return null;
  }

  if (!getGeoapifyApiKey()) {
    throw new Error('Geoapify API key is not configured');
  }

  return fetchGeoapify(trimmedQuery);
}
